module.exports = __webpack_public_path__ + "components/breakheader/background/background--3-ac46eacc4bc6ad7d706e1434153ebdd8.jpg";